import { legalCompanyDetails, privacyDocument } from "@mealmanager/legal-content";
import type { Route } from "./+types/page";
import LegalDocumentPage from "../components/LegalDocumentPage";
import { buildSeoMeta } from "../utils/seo";

export const meta: Route.MetaFunction = ({ location }) =>
  buildSeoMeta({
    location,
    title: `${privacyDocument.title} | ${legalCompanyDetails.brandName}`,
    description: `Read ${legalCompanyDetails.brandName}'s privacy policy, including how account, usage, and device data is handled across the public site and apps.`,
    type: "article",
    modifiedTime: privacyDocument.effectiveDate,
  });

export default function PrivacyPage() {
  return <LegalDocumentPage document={privacyDocument} />;
}
